import React, { PureComponent } from 'react'
import { Modal, Button, Tooltip, Table, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { getObjectWithLocales } from '../../../util/masters/masters'

import { reduxForm, Field } from 'redux-form'
import { handleKeyDown } from '../../../util/utils'

class MetadataListMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      selectedMetadatoListId: -1,
      showForm: false
    }
  }

  setFormForEdit (metadataListElement, languages, showForm = false) {
    const metadataListWithLocales = getObjectWithLocales(metadataListElement, metadataListElement.metadatoListLocales, languages)
    this.setState({ selectedMetadatoListId: metadataListElement?.metadatoListId ?? -1, showForm })
    this.props.initialize(metadataListWithLocales)
  }

  submitMetadataListFromRow () {
    this.submitMetadataList(this.props.formValues)
  }

  submitMetadataList (values) {
    let languages = []
    Object.keys(values).map(item => {
      if (!!values[item] && typeof values[item] === 'object') {
        languages.push(values[item])
      }
    })

    const metadataList = {
      metadatoListId: values.metadatoListId,
      metadatoId: values.metadatoId,
      metadatoListLocales: languages
    }

    this.props.actions.submitMetadataList(metadataList, this.props.metadata)
    this.setFormForEdit({ metadatoId: this.props.metadata.metadatoId }, this.props.languageList)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.setState({ selectedMetadatoListId: -1, showForm: false })
      const initialMetadataList = getObjectWithLocales({ metadatoId: this.props.metadata.metadatoId }, [], this.props.languageList)
      this.props.initialize(initialMetadataList)
    }
  }

  render () {
    const {
      t, handleSubmit, metadataList, languageSelected, metadataListCount, pagesCount, metadata,
      showModal, languageList,
      actions: { deleteMetadataListElement },
      filter: { page }
    } = this.props
    const tKey = 'MASTERS.METADATA_LIST_MASTERS.MODAL.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const cancelTooltip = (<Tooltip id="editTooltip">{t(`${tKey}CANCEL`)}</Tooltip>)
    const confirmTooltip = (<Tooltip id="editTooltip">{t(`${tKey}CONFIRM`)}</Tooltip>)
    return (
      <Modal id="metadataListMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeMetadataListMasterModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitMetadataList.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeMetadataListMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ paddingLeft: '20px', paddingRight: '20px' }}>
            <h2 className='masterModalSectionTitle'>{t(`${tKey}METADATA_LIST`)}</h2>
            <Table className="editable-table" hover responsive>
              <thead>
                <tr>
                  <th onClick={() => { this.changeOrder('documentTypeId') }}>
                    {t(`${tKey}NAME`)}
                  </th>
                  <th onClick={() => { this.changeOrder('documentTypeId') }}>
                    {t(`${tKey}DESCRIPTION`)}
                  </th>
                  <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                </tr>
              </thead>
              <tbody>
                {metadataList && metadataList.map((metadataListElement, idx) => {
                  return (
                    <tr key={idx} className={metadataListElement.metadatoListId === this.state.selectedMetadatoListId ? 'metadata-row selected-row' : 'metadata-row'}>
                      <td>{metadataListElement.metadatoListLocales?.find(x => x.languageId === languageSelected)?.name || ''}</td>
                      <td>{metadataListElement.metadatoListLocales?.find(x => x.languageId === languageSelected)?.description || ''}</td>
                      {this.state.selectedMetadatoListId !== metadataListElement.metadatoListId && !metadataListElement.isDeleted && (
                        <td className='actions'>
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => this.setFormForEdit(metadataListElement, languageList, true)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => deleteMetadataListElement(metadataListElement.metadatoListId, metadata)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        </td>
                      )}
                      {this.state.selectedMetadatoListId === metadataListElement.metadatoListId && !metadataListElement.isDeleted && (
                        <td className='actions'>
                          <div>
                            <OverlayTrigger placement="left" overlay={confirmTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => this.submitMetadataListFromRow()}>
                                <i className="iDocIcon-done-ok" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={cancelTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => this.setFormForEdit({ metadatoId: metadata.metadatoId }, languageList)}>
                                <i className="iDocIcon-clear-decline" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        </td>
                      )}
                    </tr>)
                })
                }
                {(metadataList === null || metadataList === undefined || metadataList.length === 0) &&
              <tr>
                <td colSpan={12}><p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p></td>
              </tr>}
              </tbody>
            </Table>
            <div className='flexInLine al-L'>
              <Button
                className="_Btn new"
                onClick={() => this.setFormForEdit({ metadatoId: metadata.metadatoId }, languageList, true)}>
                <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)}
              </Button>
            </div>
            <div className="section-users-footer">
              <nav key={1} className="text-center">
                <IDocCarPagination
                  id="btn_pag_sales"
                  page={page}
                  pagesCount={pagesCount}
                  totalRows={metadataListCount}
                  onSelectAction={(value) => true}
                />
              </nav>
            </div>
            <div className="clearfix" />
            {this.state.showForm && <>
              <SimpleTablePage
                customClass={'langTable'}
                columns={[
                  <th className='colWidth-15 alignC' key={2}>
                    {t('MASTERS.LANGUAGE')}
                  </th>,
                  <th className='colWidth-30' key={0}>
                    {t('MASTERS.FAQSECTION.TITLE_FIELD')}
                  </th>,
                  <th className='colWidth-55' key={1}>
                    {t('MASTERS.FAQSECTION.DESCRIPTION_FIELD')}
                  </th>
                ]}
                rows={languageList && languageList.map((val, idx) => (
                  <tr key={idx}>
                    <td className='alignC'>
                      <p><span>{`${val.description}`}</span></p>
                      <p>{`(${val.name})`}</p>
                    </td>
                    <td>
                      <Field
                        component={InputText}
                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                        name={`lang${val.languageId}.name`}
                        placeholder={t('MASTERS.NAME')}
                        maxLength={50}
                      />
                    </td>
                    <td>
                      <Field
                        component={InputText}
                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                        name={`lang${val.languageId}.description`}
                        placeholder={t('MASTERS.DESCRIPTION')}
                        maxLength={100}
                      />
                    </td>
                  </tr>
                ))}
              />
              <div className="flexInLine al-L">
                <Button
                  id="role-modal-submit-button"
                  className="_Btn new"
                  type="submit">
                  {t(`${tKey}SUBMIT_BUTTON`)}
                </Button>
                <Button
                  id="form-modal-submit-button"
                  className="_Btn cancel"
                  type="submit"
                  onClick={() => this.setFormForEdit({ metadatoId: metadata.metadatoId }, languageList)}>
                  {t(`${tKey}DISCARD`)}
                </Button>
              </div>
            </>
            }
          </Modal.Body>
          <Modal.Footer>
            <div className="flexInLine al-R">
              <Button
                id="metadatalist-modal-cancel-button"
                className="_Btn accept"
                onClick={this.props.actions.closeMetadataListMasterModal}>
                {t(`${tKey}CLOSE`)}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editMetadataList',
  validate: (values, props) => {
    let error = {}

    const tKey = 'MASTERS.METADATA_LIST_MASTERS.VALIDATION.'

    props.languageList && props.languageList.forEach((element) => {
      let valueLangName = values['lang' + element.languageId].name
      let valueLangDesc = values['lang' + element.languageId].description
      let errorLang = {
        name: null,
        description: null
      }
      if (!valueLangName) {
        errorLang.name = props.t(`${tKey}NAME`)
      } else if (valueLangName.length > 50) {
        errorLang.name = props.t(`${tKey}NAME_LENGTH`)
      }
      if (!valueLangDesc) {
        errorLang.description = props.t(`${tKey}DESCRIPTION`)
      } else if (valueLangDesc.length > 50) {
        errorLang.description = props.t(`${tKey}DESCRIPTION_LENGTH`)
      }
      error['lang' + element.languageId] = errorLang
    })

    return Object.keys(error).length > 0 ? error : {}
  }
})(MetadataListMasterModal)
